import { createStore } from 'vuex'
import type { UserInfo } from '@/api/user'

interface State {
  token: string
  roles: string[]
  userId: string
  userInfo: UserInfo | null
}

const USER_INFO_KEY = 'userInfo'

export default createStore<State>({
  state: {
    token: localStorage.getItem('token') || '',
    roles: JSON.parse(localStorage.getItem('roles') || '[]'),
    userId: localStorage.getItem('userId') || '',
    userInfo: JSON.parse(localStorage.getItem(USER_INFO_KEY) || 'null')
  },
  getters: {
    isAuthenticated: (state): boolean => !!state.token,
    getToken: (state): string => state.token,
    getRoles: (state): string[] => state.roles,
    hasRole: (state) => (role: string): boolean => state.roles.includes(role),
    getUserInfo: (state): UserInfo | null => state.userInfo,
    getUsername: (state): string => state.userInfo?.username || '',
    getAvailablePoints: (state): number =>
      state.userInfo?.pointsInfo?.totalAvailablePoints ?? 0
  },
  mutations: {
    SET_USER_ID(state, userId: string) {
      state.userId = userId
      localStorage.setItem('userId', userId)
    },
    SET_USER_INFO(state, userInfo: UserInfo | null) {
      state.userInfo = userInfo
      if (userInfo) {
        state.userId = userInfo.userId
        localStorage.setItem('userId', userInfo.userId)
        localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
      } else {
        localStorage.removeItem(USER_INFO_KEY)
      }
    },
    SET_TOKEN(state, token: string) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_ROLES(state, roles: string[]) {
      state.roles = roles
      localStorage.setItem('roles', JSON.stringify(roles))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.roles = []
      state.userId = ''
      state.userInfo = null
      localStorage.removeItem('token')
      localStorage.removeItem('roles')
      localStorage.removeItem('userId')
      localStorage.removeItem(USER_INFO_KEY)
    }
  },
  actions: {
    logout({ commit }) { commit('CLEAR_AUTH') }
  },
  modules: {}
})